module.exports = __webpack_public_path__ + "static/media/400047_01.389d3b78.png";